import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import type { MessageTemplatesResponse } from '@chatapp-inbox/shared';
import forms from '../admin/forms.module.css';
import { TemplatePicker } from './TemplatePicker';
import { loadErrorMessage } from './form';
import type { TemplatePickerState } from './use-template-picker';
import styles from './TemplateChooser.module.css';

/**
 * A parte das janelas de modelo que depende da lista da Meta: carregando, erro (com "tentar de novo"),
 * lista vazia ou a escolha do modelo.
 */
export function TemplateChooser({
  templates,
  picker,
  busy,
}: {
  templates: UseQueryResult<MessageTemplatesResponse>;
  picker: TemplatePickerState;
  busy: boolean;
}): ReactElement {
  if (templates.isPending) {
    return (
      <p role="status" className={forms.hint}>
        Carregando modelos…
      </p>
    );
  }
  if (templates.isError || !templates.data) {
    return (
      <div className={styles.state}>
        <p role="alert" className={forms.alert}>
          {loadErrorMessage(templates.error)}
        </p>
        <button type="button" className={styles.retry} onClick={() => void templates.refetch()}>
          Tentar de novo
        </button>
      </div>
    );
  }
  if (templates.data.templates.length === 0) {
    return (
      <div className={styles.state}>
        <p role="status" className={forms.hint}>
          Nenhum modelo aprovado foi encontrado. Crie um no Gerenciador do WhatsApp (Meta) e espere
          a aprovação; a lista pode levar até 1 minuto para atualizar.
        </p>
        <button type="button" className={styles.retry} onClick={() => void templates.refetch()}>
          Atualizar a lista
        </button>
      </div>
    );
  }
  return <TemplatePicker picker={picker} busy={busy} />;
}
